import { FullDataCell, FullDataCellContent } from 'components/data_table/styled';
import { BaseTableRowProps, TableProps } from 'components/data_table/types';
import { CSSProperties } from 'react';

export type FullTableRowProps<TData> = BaseTableRowProps<TData> &
    Pick<TableProps<TData>, 'columns'> &
    Readonly<{
        /**
         * Styles used for column locking.
         */
        lockStyles: CSSProperties[];
    }>;

export function FullTableRow<TData>({
    columns,
    valueCell,
    lockStyles,
    tableStyle = 'data',
}: FullTableRowProps<TData>) {
    return (
        <tr>
            {columns.map((columnInfo, columnIndex) => (
                <FullDataCell
                    className={columnInfo.valueClassName}
                    key={columnInfo.id}
                    style={lockStyles[columnIndex]}
                >
                    <FullDataCellContent
                        style={{
                            minWidth: columnInfo.minWidth,
                            width: columnInfo.width,
                            maxWidth: columnInfo.maxWidth,
                        }}
                        $tableStyle={tableStyle}
                    >
                        {valueCell(columnInfo)}
                    </FullDataCellContent>
                </FullDataCell>
            ))}
        </tr>
    );
}
